document.addEventListener('DOMContentLoaded', function () {
  console.log('modal-collection.js loaded');
  const quickViewButton = document.querySelectorAll('.cta-quik-view');
  const containerCarrousel = document.querySelectorAll('.container-carrousel-images-product');
  const containerInfoDesktop = document.querySelectorAll('.container-info-rpoduct');
  const containerInfoMobile = document.querySelectorAll('.container-images-info-mobile');
  const swiperContainers = document.querySelectorAll('.swiper.thumbnails-swiper-mobile');

  swiperContainers.forEach((swiperContainer) => {
    var swiper = new Swiper(swiperContainer, {
      effect: 'coverflow',
      loop: true,
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      coverflowEffect: {
        rotate: 0,
        stretch: -10,
        depth: 50,
        modifier: 3,
        slideShadows: false,
      },
    });
  });

  containerInfoMobile.forEach(container => {
    const ctaAddToCart = container.querySelector('.cta-add-to-cart-mobile');
    const customSelects = container.querySelectorAll(".custom-select");
    const variantSizeSelector = container.querySelector(".variant-selector");
    console.log('Container Info Mobile:', container);
    console.log('vaariatSizeSelector:', variantSizeSelector);

    if (variantSizeSelector) {
      variantSizeSelector.addEventListener("change", (event) => {
        const productHandle = container.getAttribute('data-product-handle');
        const selectorColor = container.querySelector('.select-button');


        let objectProduct = '';

        fetch(`${window.Shopify.routes.root}products/${productHandle}.js`)
          .then(response => {
            if (!response.ok) {
              throw new Error('Error fetching product data');
            }
            return response.json();
          })
          .then(product => {
            objectProduct = product;
            console.log('Product fetched:', objectProduct);
            const variantNameColor = selectorColor.getAttribute('data-name-color');
            const variantNameSize = event.target.value;

            console.log('Variant Name Color:', variantNameColor);
            console.log('Variant Name Size:', variantNameSize);

            const matchingVariant = objectProduct.variants.find(v =>
              (v.option1 === variantNameColor && v.option2 === variantNameSize) ||
              (v.option1 === variantNameSize && v.option2 === variantNameColor)
            );

            let idVariant = matchingVariant ? matchingVariant.id : null;

            if (idVariant) {
              console.log('Matching Variant:', matchingVariant);
              ctaAddToCart.setAttribute('data-variant-id', idVariant);
              ctaAddToCart.classList.remove('disabled');
            } else {
              ctaAddToCart.classList.add('disabled');
            }
          })
          .catch(error => {
            console.error('Error:', error);
          });
      });
    }



    customSelects.forEach((customSelect) => {
      const selectButton = customSelect.querySelector(".select-button");
      const dropdown = customSelect.querySelector(".select-dropdown");
      const options = dropdown.querySelectorAll("li");
      const selectedValue = selectButton.querySelector(".selected-value");

      let focusedIndex = -1;

      const toggleDropdown = (expand = null) => {
        const isOpen =
          expand !== null ? expand : dropdown.classList.contains("hidden");
        dropdown.classList.toggle("hidden", !isOpen);
        selectButton.setAttribute("aria-expanded", isOpen);

        if (isOpen) {
          focusedIndex = [...options].findIndex((option) =>
            option.classList.contains("selected")
          );
          focusedIndex = focusedIndex === -1 ? 0 : focusedIndex;
          updateFocus();
        } else {
          focusedIndex = -1;
          selectButton.focus();
        }
      };

      const updateFocus = () => {
        options.forEach((option, index) => {
          if (option) {
            option.setAttribute("tabindex", index === focusedIndex ? "0" : "-1");
            if (index === focusedIndex) option.focus();
          }
        });
      };

      const handleOptionSelect = (option) => {
        options.forEach((opt) => opt.classList.remove("selected"));
        option.classList.add("selected");
        selectedValue.innerHTML = option.innerHTML.trim();
        selectButton.setAttribute("data-name-color", option.getAttribute("data-name-variant"));

        if (option.dataset.value === "clear") {
          // Reset to the default value
          selectedValue.textContent = "Open this select menu";
          options.forEach((opt) => opt.classList.remove("selected"));
          return;
        }
      };

      const setVariantId = (option, customSelect) => {

        const containerImages = container.querySelector('.container-images-mobile');
        const carrouselsImages = containerImages.querySelectorAll('.container-carrousel-images-product-mobile')

        if (customSelect.classList.contains('one-option')) {
          const variantId = option.getAttribute("data-variant-id");
          if (variantId) {
            ctaAddToCart.setAttribute("data-variant-id", variantId);
            ctaAddToCart.classList.remove("disabled");

            carrouselsImages.forEach(carousel => {
              const idCarrousel = carousel.getAttribute('data-variant-id');
              console.log('ID Carrousel:', idCarrousel);
              carousel.classList.add('hide');

              if (idCarrousel) {
                if (idCarrousel == variantId) {
                  carousel.classList.remove('hide');
                }
              }
            });
          } else {
            ctaAddToCart.classList.add("disabled");
          }
        } else if (customSelect.classList.contains('two-options')) {
          const containerVariantSize = container.querySelector('.select-wrapper-variant');
          const variantsSelectorSize = containerVariantSize.querySelector('.variant-selector');
          const productHandle = container.getAttribute('data-product-handle');


          let objectProduct = '';

          fetch(`${window.Shopify.routes.root}products/${productHandle}.js`)
            .then(response => {
              if (!response.ok) {
                throw new Error('Error fetching product data');
              }
              return response.json();
            })
            .then(product => {
              objectProduct = product;
              console.log('Product fetched:', objectProduct);
              const variantNameColor = option.getAttribute('data-name-variant');
              const variantNameSize = variantsSelectorSize.value;

              console.log('Variant Name Color:', variantNameColor);
              console.log('Variant Name Size:', variantNameSize);

              const matchingVariant = objectProduct.variants.find(v =>
                (v.option1 === variantNameColor && v.option2 === variantNameSize) ||
                (v.option1 === variantNameSize && v.option2 === variantNameColor)
              );

              let idVariant = matchingVariant ? matchingVariant.id : null;

              if (idVariant) {
                ctaAddToCart.setAttribute('data-variant-id', idVariant);
                ctaAddToCart.classList.remove('disabled');

                carrouselsImages.forEach(carousel => {
                  const idCarrousel = carousel.getAttribute('data-variant-id');
                  console.log('ID Carrousel:', idCarrousel);
                  carousel.classList.add('hide');

                  if (idCarrousel) {
                    if (idCarrousel == idVariant) {
                      carousel.classList.remove('hide');
                    }
                  }
                });
              } else {
                ctaAddToCart.classList.add('disabled');
              }
            })
            .catch(error => {
              console.error('Error:', error);
            });
        }

      };

      options.forEach((option) => {
        option.addEventListener("click", () => {
          handleOptionSelect(option);
          toggleDropdown(false);
          setVariantId(option, customSelect);
        });
      });

      selectButton.addEventListener("click", () => {
        toggleDropdown();
      });

      selectButton.addEventListener("keydown", (event) => {
        if (event.key === "ArrowDown") {
          event.preventDefault();
          toggleDropdown(true);
        } else if (event.key === "Escape") {
          toggleDropdown(false);
        }
      });

      dropdown.addEventListener("keydown", (event) => {
        if (event.key === "ArrowDown") {
          event.preventDefault();
          focusedIndex = (focusedIndex + 1) % options.length;
          updateFocus();
        } else if (event.key === "ArrowUp") {
          event.preventDefault();
          focusedIndex = (focusedIndex - 1 + options.length) % options.length;
          updateFocus();
        } else if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          handleOptionSelect(options[focusedIndex]);
          toggleDropdown(false);
        } else if (event.key === "Escape") {
          toggleDropdown(false);
        }
      });
    });

    ctaAddToCart.addEventListener('click', function () {
      const idVariant = this.getAttribute('data-variant-id');

      if (idVariant && !this.classList.contains('disabled')) {
        fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ id: idVariant, quantity: 1 })
        })
          .then(response => {
            if (!response.ok) {
              throw new Error('Error adding to cart');
            }
            return response.json();
          })
          .then(data => {
            console.log('Added to cart:', data);

            function dispatchCustomEvent(eventName, detail = {}, target = document) {
              const event = new CustomEvent(eventName, {
                detail,
                bubbles: true,
                cancelable: true,
              });
              target.dispatchEvent(event);
            }

            dispatchCustomEvent('shopify:custom:add-to-cart', {
              userId: 123,
              action: 'clicked',
            });
            console.log('Evento personalizado disparado: shopify:custom:add-to-cart')
          })
          .catch(error => {
            console.error('Error:', error);
          });
      }
    });
  });

  containerInfoDesktop.forEach(container => {
    const containerVariantColorSingle = container.querySelector('.container-variants-circles.one-option');
    const containerVariantColor = container.querySelector('.container-variants-circles.two-options');
    const containerTabs = container.querySelector('.container-product-tabs');
    const ctaAddToCart = container.querySelector('.cta-add-to-cart-desktop');
    const parentElement = container.closest('.container-images-info');
    const carrouselsImages = parentElement.querySelectorAll('.container-carrousel-images-product');

    if (containerVariantColorSingle) {
      const variantSelector = containerVariantColorSingle.querySelectorAll('.variant-outer-circle');

      variantSelector.forEach(variant => {
        variant.addEventListener('click', function () {
          variantSelector.forEach(v => v.classList.remove('selected'));
          this.classList.add('selected');

          const variantId = this.getAttribute('data-variant-id');
          const varaintAvailable = this.getAttribute('data-variant-available');

          if (varaintAvailable === 'true') {
            ctaAddToCart.setAttribute('data-variant-id', variantId);
            ctaAddToCart.classList.remove('disabled');
          } else {
            ctaAddToCart.classList.add('disabled');
          };

          carrouselsImages.forEach(carousel => {
            const idCarrousel = carousel.getAttribute('data-variant-id');
            carousel.classList.add('hide');

            if (idCarrousel) {
              if (idCarrousel == variantId) {
                carousel.classList.remove('hide');
              }
            }
          });
        });
      });
    }

    if (containerVariantColor) {
      const containerVariantSize = container.querySelector('.select-wrapper-variant');
      const variantsSelectorColor = containerVariantColor.querySelectorAll('.variant-outer-circle');
      const variantsSelectorSize = containerVariantSize.querySelector('.variant-selector');
      const productHandle = container.getAttribute('data-product-handle');
      const containerImages = container.querySelector('.container-images');

      let objectProduct = '';

      fetch(`${window.Shopify.routes.root}products/${productHandle}.js`)
        .then(response => {
          if (!response.ok) {
            throw new Error('Error fetching product data');
          }
          return response.json();
        })
        .then(product => {
          objectProduct = product;
          console.log('Product fetched:', objectProduct);
          variantsSelectorColor.forEach(variant => {
            variant.addEventListener('click', function () {
              const variantNameColor = this.getAttribute('data-name-variant');
              const variantNameSize = variantsSelectorSize.value;

              const matchingVariant = objectProduct.variants.find(v =>
                (v.option1 === variantNameColor && v.option2 === variantNameSize) ||
                (v.option1 === variantNameSize && v.option2 === variantNameColor)
              );

              let idVariant = matchingVariant ? matchingVariant.id : null;

              if (idVariant) {
                ctaAddToCart.setAttribute('data-variant-id', idVariant);
                ctaAddToCart.classList.remove('disabled');

                carrouselsImages.forEach(carousel => {
                  const idCarrousel = carousel.getAttribute('data-variant-id');
                  console.log('ID Carrousel:', idCarrousel);
                  carousel.classList.add('hide');

                  if (idCarrousel) {
                    if (idCarrousel == idVariant) {
                      carousel.classList.remove('hide');
                    }
                  }
                });
              } else {
                ctaAddToCart.classList.add('disabled');
              }

              variantsSelectorColor.forEach(v => v.classList.remove('selected'));
              this.classList.add('selected');
            });
          });
          variantsSelectorSize.addEventListener('change', function () {
            const variantNameSize = this.value;
            const selectedColorVariant = containerVariantColor.querySelector('.variant-outer-circle.selected');
            const variantNameColor = selectedColorVariant ? selectedColorVariant.getAttribute('data-name-variant') : '';

            const matchingVariant = objectProduct.variants.find(v =>
              (v.option1 === variantNameColor && v.option2 === variantNameSize) ||
              (v.option1 === variantNameSize && v.option2 === variantNameColor)
            );

            let idVariant = matchingVariant ? matchingVariant.id : null;

            if (idVariant) {
              ctaAddToCart.setAttribute('data-variant-id', idVariant);
              ctaAddToCart.classList.remove('disabled');
            } else {
              ctaAddToCart.classList.add('disabled');
            }
          });
        })
        .catch(error => {
          console.error('Error:', error);
        });
    }

    if (containerTabs) {
      const tabs = containerTabs.querySelectorAll('.individual-title');

      tabs.forEach(tab => {
        tab.addEventListener('click', function () {
          const infoTabs = containerTabs.querySelectorAll('.info-tab');
          const progressBar = containerTabs.querySelector('.dynamicBar');
          const infoTab1 = containerTabs.querySelector('.info-tab1');
          const infoTab2 = containerTabs.querySelector('.info-tab2');
          const infoTab3 = containerTabs.querySelector('.info-tab3');

          infoTabs.forEach(infoTab => {
            infoTab.classList.add('hide');
          });

          if (this.classList.contains('individual-title1')) {
            infoTab1.classList.remove('hide');
            progressBar.classList.add('z1');
            progressBar.classList.remove('z2', 'z3');
          } else if (this.classList.contains('individual-title2')) {
            infoTab2.classList.remove('hide');
            progressBar.classList.add('z2');
            progressBar.classList.remove('z1', 'z3');
          } else if (this.classList.contains('individual-title3')) {
            infoTab3.classList.remove('hide');
            progressBar.classList.add('z3');
            progressBar.classList.remove('z1', 'z2');
          }
        });
      });
    }

    ctaAddToCart.addEventListener('click', function () {
      const idVariant = this.getAttribute('data-variant-id');

      if (idVariant && !this.classList.contains('disabled')) {
        fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ id: idVariant, quantity: 1 })
        })
          .then(response => {
            if (!response.ok) {
              throw new Error('Error adding to cart');
            }
            return response.json();
          })
          .then(data => {
            console.log('Added to cart:', data);

            function dispatchCustomEvent(eventName, detail = {}, target = document) {
              const event = new CustomEvent(eventName, {
                detail,
                bubbles: true,
                cancelable: true,
              });
              target.dispatchEvent(event);
            }

            dispatchCustomEvent('shopify:custom:add-to-cart', {
              userId: 123,
              action: 'clicked',
            });
            console.log('Evento personalizado disparado: shopify:custom:add-to-cart')
          })
          .catch(error => {
            console.error('Error:', error);
          });
      }
    });


  });

  quickViewButton.forEach(button => {
    button.addEventListener('click', function () {
      const allContainers = document.querySelectorAll('.container-quick-view');
      const parentElement = this.closest('.product-grid-item');
      const quickViewContainer = parentElement.querySelector('.container-quick-view');
      const backgroundOpacity = parentElement.querySelector('.background-opacity');
      const closeIcon = parentElement.querySelector('.icon-close-quick-view')

      allContainers.forEach(container => {
        if (!container.classList.contains('hide')) {
          container.classList.add('hide');
        }
      });

      quickViewContainer.classList.remove('hide');
      backgroundOpacity.classList.remove('hide');
      document.body.classList.add('no-scroll');

      closeIcon.addEventListener('click', function () {
        quickViewContainer.classList.add('hide');
        backgroundOpacity.classList.add('hide');
        document.body.classList.remove('no-scroll');
      });
    });
  });

  if (document.querySelectorAll('.thumbnails-swiper').length > 0) {
    new Swiper('.thumbnails-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 12,
      freeMode: true,
      grabCursor: true,
    });
  };

  containerCarrousel.forEach(container => {
    const mainImages = container.querySelector('.image-product img');
    const thumbnails = container.querySelectorAll('.image-thumbnail');

    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', function () {
        const thumbnailImage = this.querySelector('img');
        mainImages.src = thumbnailImage.src;
      });
    });
  });
});